import { Typography } from '..'
import Icon from '../Icon'
import { Space } from '../space'
import { getToastBackgrounColor, getToastBorderColor } from '../types/mapper'
import { MessageType } from '../types/types'
import { StyledSnackbar, StyledToast, StyledToastCloseIcon } from './toastNotification.styles'

export interface ToastNotificationProps {
  autoHideDuration?: number
  description: string
  notificationType: MessageType
  onClose: () => void
  open: boolean
  title: string
}

export const ToastNotification = ({
  autoHideDuration,
  description,
  notificationType,
  onClose,
  open,
  title
}: ToastNotificationProps) => {
  const duration = autoHideDuration || 7500
  const backgroundColor = getToastBackgrounColor(notificationType)
  const borderColor = getToastBorderColor(notificationType)
  const isSuccess = notificationType === 'success'
  const notificationIcon = isSuccess ? 'circleCheck' : 'circleX'
  return (
    <StyledSnackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={duration}
      open={open}
      onClose={onClose}
    >
      <StyledToast
        isflex
        background={backgroundColor}
        border={borderColor}
        flexDirection="row"
        p={4}
      >
        <Space isflex flexDirection="row">
          <Icon name={`${notificationIcon}`} size="large" />
          <Space isflex flexDirection="column" flexGrow={1} ml={4}>
            <Space mb={2}>
              <Typography variant="b2">{title}</Typography>
            </Space>
            <Typography variant="b3">{description}</Typography>
          </Space>
        </Space>
        <StyledToastCloseIcon ml={4} onClick={() => onClose()}>
          <Icon name="remove" size="default" />
        </StyledToastCloseIcon>
      </StyledToast>
    </StyledSnackbar>
  )
}

export default ToastNotification
